// Simple test to debug the API issue
import borisApiService from './services/BorisApiService';

const testAPI = async () => {
  try {
    console.log('🔍 Testing Boris API...');
    
    // Test connection
    console.log('1. Testing connection...');
    const isConnected = await borisApiService.testConnection();
    console.log('Connection:', isConnected);
    
    // Test user creation (if endpoint exists)
    console.log('2. Testing user creation...');
    try {
      const testUser = await borisApiService.createUser({
        name: 'Test User',
        email: 'test@example.com',
        telephone: '+1234567890',
        accepts_promotional_emails: true,
        source: 'test_api',
        metadata: {
          test: true,
          timestamp: new Date().toISOString()
        }
      });
      console.log('User created:', testUser);
    } catch (userError) {
      console.log('User creation failed (expected if endpoint not implemented):', userError.message);
    }
    
    // Create session
    console.log('3. Creating session...');
    const session = await borisApiService.createSession('test-user-123');
    console.log('Session created:', session);
    
    // Send message
    console.log('4. Sending message...');
    const response = await borisApiService.sendMessage("Hi, I need project management software");
    console.log('Response:', response);
    
    console.log('✅ All tests passed!');
    
  } catch (error) {
    console.error('❌ Test failed:', error);
    console.error('Error details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      config: {
        url: error.config?.url,
        method: error.config?.method,
        data: error.config?.data
      }
    });
    
    // Log the full error response if available
    if (error.response?.data?.detail) {
      console.error('📋 Validation Details:', error.response.data.detail);
    }
  }
};

// Auto-run test when imported
testAPI();

export default testAPI;
